import { render } from "./AuthorizedContactsForm.vue?vue&type=template&id=de8d7f30&ts=true"
import script from "./AuthorizedContactsForm.ts?vue&type=script&lang=ts&external"
export * from "./AuthorizedContactsForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__